import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { Landing } from "./pages/desktop/landing/landing";
import { Details } from "./pages/desktop/details/details";

import { MobileLanding } from "./pages/mobile/landing/mobileLanding";
import { MobileDetails } from "./pages/mobile/details/mobileDetails";

import { Login } from "./pages/desktop/login/login";
import { MobileLogin } from "./pages/mobile/login/mobileLogin";

const isMobile = () =>
  window.innerWidth <= 768 ||
  /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
    navigator.userAgent
  );

const isLoggedIn = () => {
  const salesPersonId = localStorage.getItem("salesPersonId");

  return (
    salesPersonId &&
    salesPersonId !== "null" &&
    salesPersonId !== "undefined" &&
    salesPersonId !== ""
  );
};

const RootRedirect = () => {
  const mobile = isMobile();

  if (isLoggedIn()) {
    return (
      <Navigate
        to={mobile ? "/mobile" : "/landing"}
        replace
      />
    );
  }

  return (
    <Navigate
      to={mobile ? "/mobile/login" : "/login"}
      replace
    />
  );
};

const ProtectedRoute = ({ children, mobile = false }) => {
  const loggedIn = isLoggedIn();
  const actualMobile = isMobile();

  // Not logged in
  if (!loggedIn) {
    return (
      <Navigate
        to={actualMobile ? "/mobile/login" : "/login"}
        replace
      />
    );
  }

  // Mobile device trying desktop route
  if (actualMobile && !mobile) {
    return <Navigate to="/mobile" replace />;
  }

  // Desktop device trying mobile route
  if (!actualMobile && mobile) {
    return <Navigate to="/landing" replace />;
  }

  return children;
};

const LoginRoute = ({ mobile = false, children }) => {
  const loggedIn = isLoggedIn();
  const actualMobile = isMobile();

  // Already logged in
  if (loggedIn) {
    return (
      <Navigate
        to={actualMobile ? "/mobile" : "/landing"}
        replace
      />
    );
  }

  // Wrong login page for device
  if (actualMobile && !mobile) {
    return <Navigate to="/mobile/login" replace />;
  }

  if (!actualMobile && mobile) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Root */}
        <Route path="/" element={<RootRedirect />} />

        {/* Desktop Login */}
        <Route
          path="/login"
          element={
            <LoginRoute>
              <Login />
            </LoginRoute>
          }
        />

        {/* Mobile Login */}
        <Route
          path="/mobile/login"
          element={
            <LoginRoute mobile>
              <MobileLogin />
            </LoginRoute>
          }
        />

        {/* Desktop Pages */}
        <Route
          path="/landing"
          element={
            <ProtectedRoute>
              <Landing />
            </ProtectedRoute>
          }
        />

        <Route
          path="/details/:partyId"
          element={
            <ProtectedRoute>
              <Details />
            </ProtectedRoute>
          }
        />

        {/* Mobile Pages */}
        <Route
          path="/mobile"
          element={
            <ProtectedRoute mobile>
              <MobileLanding />
            </ProtectedRoute>
          }
        />

        <Route
          path="/mobile/details/:partyId"
          element={
            <ProtectedRoute mobile>
              <MobileDetails />
            </ProtectedRoute>
          }
        />

        {/* Catch All */}
        <Route path="*" element={<RootRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;